import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ActionsEnum as AppActionsEnum } from '../../store/app.actions';
import { ActionsEnum, TrackEvent, TrackPage } from './tracking.actions';
import { I2gNgTrackingService } from 'i2g-ng-tracking';
import { environment } from '../../../environments/environment';

@Injectable()
export class TrackingEffects {
  constructor(
    private _actions: Actions,
    private _trackingService: I2gNgTrackingService
  ) {}

  @Effect({ dispatch: false })
  onAppInit: Observable<any> = this._actions.pipe(
    ofType(AppActionsEnum.INIT_APP),
    take(1),
    tap(() => {
      this._trackingService.load(environment.segmentWriteKey, {
        app_name: 'web_app',
        app_version: environment.version,
      });
    })
  );

  @Effect({ dispatch: false })
  trackPage: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.TRACK_PAGE),
    tap(({ payload }: TrackPage) =>
      this._trackingService.trackPage(
        payload.trackingScreenName,
        payload.properties
      )
    )
  );

  @Effect({ dispatch: false })
  trackEvent: Observable<any> = this._actions.pipe(
    ofType(ActionsEnum.TRACK_EVENT),
    tap(({ payload }: TrackEvent) =>
      this._trackingService.trackEvent(
        payload.trackingObjects,
        payload.trackingAction,
        payload.additionalProperties
      )
    )
  );
}
